import api from './clients';

export const invoicesApi = {
  getAll: async (params?: any) => {
    const response = await api.get('/invoices', { params });
    return response.data?.data || response.data || [];
  },
  getById: async (id: number) => {
    const response = await api.get(`/invoices/${id}`);
    return response.data?.data || response.data;
  },
  create: async (data: any) => {
    const response = await api.post('/invoices', data);
    return response.data?.data || response.data;
  },
  update: async (id: number, data: any) => {
    const response = await api.put(`/invoices/${id}`, data);
    return response.data?.data || response.data;
  },
  delete: async (id: number) => {
    const response = await api.delete(`/invoices/${id}`);
    return response.data;
  },
  generatePDF: async (id: number) => {
    const response = await api.post(`/invoices/${id}/pdf`);
    return response.data?.data || response.data;
  },
};